<div class="pyro">
    <div class="before"></div>
    <div class="after"></div>
</div>